import { Burger, Scrollbar } from '../core'
import { Mobile } from '../core'

export default {

  init() {
    $.mlmi = {
      mobile: new Mobile(),
    }

    /* Burger */
    let obj = this
    obj.burger = new Burger('.header__burger', {
      onToggle: function() {
        if (obj.burger.isExpanded) {
          $('body').removeClass('--search-open')
          $('body').addClass('--menu-open')
        } else {
          $('body').removeClass('--menu-open')
        }
      },
    })

    var menu_scrollbar = new Scrollbar('.header__menu', {
      direction: 'vertical',
      desktop: true,
      mobile: true,
    })

    $('.main-menu a[href=#], .drawer').click(function() {
      event.preventDefault();
      if ($(this).closest('.main-menu__item').hasClass('--open')) {
        $(this).closest('.main-menu__item').removeClass('--open')
      } else {
        $('.main-menu__item').removeClass('--open')
        $(this).closest('.main-menu__item').addClass('--open')
        $(this).next('.main-menu__sub-menu').css('--max-height', $(this).next('.main-menu__sub-menu').find('.height-ruler').height() + 'px')
      }
    });

    $('.main-menu__sub-menu').each(function() {
      $(this).wrapInner('<div class="height-ruler"></div>')
    });

    $('.header__search-toggle').click(function() {
      if ($('body').hasClass('--search-open')) {
        $('body').removeClass('--search-open')
      } else {
        $('.header .event-filters__search-field').val('')
        $('body').addClass('--search-open')
        $('body').removeClass('--menu-open')
        $('.burger').attr('aria-expanded', 'false')
        $('.header .event-filters__search-field').focus()
        $('.header .event-filters__search .field--type-text').addClass('field--empty').addClass('field--focused').removeClass('field--populated')
      }
    });

    $('body').click(function(e) {
      if ($(e.target).closest('.header__search').length == 0 && $(e.target).closest('.header__search-toggle').length == 0) {
        $('body').removeClass('--search-open')
      }
    });
  }
}
